var React = require('react');

function AppleSmallIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .apple-icon {\n        fill: #b6b6b6;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"icon","className":"apple-icon","d":"M1288.4,499.569a4.244,4.244,0,0,1,3.12,1.795,3.709,3.709,0,0,0-1.86,3.116,3.477,3.477,0,0,0,2.34,3.268s-1.84,4.258-3.91,4.258c-1.17,0-1.25-.652-2.79-0.652-1.35,0-1.8.652-2.82,0.652-1.96,0-4.48-4.15-4.48-7.526,0-3.507,2.55-4.911,4.16-4.911,1.4,0,1.99.806,3.12,0.806C1286.23,500.375,1286.98,499.569,1288.4,499.569Zm-0.33-3.575a3.441,3.441,0,0,1-3.23,3.775A3.573,3.573,0,0,1,1288.07,495.994Z","transform":"translate(-1278 -496)","key":1})]);
}

AppleSmallIcon.defaultProps = {"width":"14","height":"16","viewBox":"0 0 14 16"};

module.exports = AppleSmallIcon;

AppleSmallIcon.default = AppleSmallIcon;
